import React from 'react'
import './Button.css'

type ButtonProps = {
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  children?: React.ReactNode
  leftIcon?: React.ReactNode
  rightIcon?: React.ReactNode
  label?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const Button: React.FC<ButtonProps> = ({
  className = '',
  onClick = () => {},
  children,
  leftIcon,
  rightIcon,
  label = '',
  size = 'md',
  ...props
}) => {
  return (
    <button
      className={`button button-${size} ${className}`}
      onClick={onClick}
      {...props}
    >
      {leftIcon && (
        <span className="button-icon button-icon-left">{leftIcon}</span>
      )}
      {label && <span className="button-label">{label}</span>}
      {children}
      {rightIcon && (
        <span className="button-icon button-icon-right">{rightIcon}</span>
      )}
    </button>
  )
}

export default Button
